module.exports = __webpack_public_path__ + "img/product-2.79adfa84.jpg";